import React from 'react';
import Select from 'react-select';
import autobind from 'autobind-decorator';

type Props = {
  options: {
    value: string | number,
    label: string | number,
  }[],
  valArray: string[] | number[],
  onChange: (value: any) => void,
  menuPortalTarget?: HTMLElement | null,
};

const compactSelectStyles = {
  control: (base) => ({
    ...base,
    minHeight: 32,
    height: 32,
    width: '100%',
    borderColor: '#cccccc',
    borderRadius: 2,
    boxShadow: 'none',
    fontFamily: 'PT Sans, sans-serif',
    fontSize: 13,
    '&:hover': {
      borderColor: '#aaaaaa',
    },
  }),
  container: (base) => ({
    ...base,
    width: '100%',
  }),
  valueContainer: (base) => ({
    ...base,
    height: 30,
    padding: '0 8px',
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  placeholder: (base) => ({
    ...base,
    margin: 0,
    color: '#999999',
    fontStyle: 'italic',
    fontSize: 13,
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: 30,
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: 4,
    color: '#666666',
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: 4,
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: '#e6f2fa',
    margin: '1px 2px',
  }),
  multiValueLabel: (base) => ({
    ...base,
    fontSize: 12,
    color: 'rgb(10, 60, 93)',
    padding: '0 4px',
  }),
  option: (base, state) => ({
    ...base,
    fontFamily: 'PT Sans, sans-serif',
    fontSize: 14,
    lineHeight: '14px',
    fontWeight: 400,
    padding: '8px 12px',
    backgroundColor: state.isFocused
      ? '#e6f2fa'
      : state.isSelected
        ? 'rgb(10, 60, 93)'
        : '#ffffff',
    color: state.isSelected && !state.isFocused
      ? '#ffffff'
      : 'rgb(33, 37, 41)',
  }),
  menu: (base) => ({
    ...base,
    marginTop: 2,
    border: '1px solid #dddddd',
    borderRadius: 2,
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12)',
    zIndex: 1300,
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 1400,
  }),
};

export default class MultiSelect extends React.PureComponent<Props> {

  @autobind
  handleChange(valueObjArray: any) {
    const { onChange } = this.props;
    const val = (valueObjArray || []).map(valObj => {return (valObj.value)});
    return onChange(val);
  }

  renderSelectField = () => {
    const { options, valArray, menuPortalTarget } = this.props;
    const values = options.filter(({
      value
    }) => (valArray || []).includes(value));
    return (
        <Select
        isMulti
        value={values}
        options={options}
        placeholder="Select..."
        className="basic-multi-select"
        classNamePrefix="select"
        onChange={this.handleChange}
        menuPortalTarget={menuPortalTarget === undefined ? document.body : menuPortalTarget}
        menuPosition="fixed"
        closeMenuOnSelect={false}
        blurInputOnSelect={false}
        styles={compactSelectStyles}
      />
    );
  }

  render() {
    return (
      <div className="filter-multi-select">
        {this.renderSelectField()}
      </div>
    );
  }
}
